import { useLocation } from "react-router-dom";
import logo from "../../../assets/images/icons/dome-logo.svg";
import { LanguageSwitcher } from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { useGetData } from "../../../hooks";
import { ManagementContactType } from "../../../interface/GeneralResponse";
import "react-quill/dist/quill.snow.css";

interface IPrivacyPolicy {
  classname?: string;
}

const PrivacyPolicy: React.FC<IPrivacyPolicy> = ({ classname = "" }) => {
  const { pathname } = useLocation();
  const { data } = useGetData<ManagementContactType>(
    EndPoints.GetManagementContact,
  );
  const getContent = () => {
    return data?.Data?.PrivacyPolicy || data?.Data?.PrivacyPolicyEn || "";
  };
  return (
    <div>
      <div
        className={
          "bg-white py-6 shadow-[0px_7px_17.1px_0px_rgba(22,60,255,0.08)] lg:p-6"
        }
      >
        <div className="mx-6 flex justify-between">
          {!pathname?.includes("about_us") && (
            <img alt="logo" className="max-w-32 lg:max-w-40" src={logo} />
          )}
          <LanguageSwitcher />
        </div>
      </div>
      <div className="h-full max-h-[88vh] overflow-auto bg-white lg:p-10">
        <div className={`lg:box !p-6 lg:!p-4 ${classname}`}>
          <div className="ql-snow">
            <div className="ql-editor">
              <div dangerouslySetInnerHTML={{ __html: getContent() }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
